module.exports = __webpack_public_path__ + "heart.png";